import type { Contact } from 'store/vat-checker/models';

export type ContactNameOption = { label: string; value: string; name?: string };

export function formatContactDisplayLabel(
  name: string,
  taxNumber?: string | null
): string {
  const trimmedName = String(name ?? '').trim();
  const trimmedTax = String(taxNumber ?? '').trim();
  if (trimmedName && trimmedTax) return `${trimmedName} (${trimmedTax})`;
  return trimmedName || trimmedTax;
}

/** Dropdown options for contactName fields: label may include tax number, value is plain contact name. */
export function buildContactNameValueOptions(
  contacts: Contact[] | undefined | null
): ContactNameOption[] {
  const seen = new Set<string>();
  return [...(contacts ?? [])]
    .map((contact) => {
      const name = String(contact?.name ?? '').trim();
      if (!name || seen.has(name.toLowerCase())) return null;
      seen.add(name.toLowerCase());
      return {
        label: formatContactDisplayLabel(name, contact.taxNumber),
        value: contact.contactUuid,
        name,
      };
    })
    .filter((o): o is ContactNameOption => o != null)
    .sort((a, b) => a.label.localeCompare(b.label));
}
